module.exports = __webpack_public_path__ + "img/base-pathplan-814d2af0.png";